import { render } from "./Contact.vue?vue&type=template&id=4bf60df4&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=4bf60df4&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf60df4"]])

export default __exports__